import styled from '@emotion/styled';
import { MOBILE_QRY } from '~/config';

const MainContainer = styled.div`
  width: 100%;
  padding: 20px 14px;

  ${MOBILE_QRY} {
    padding: 34px;
  }
`;

export default MainContainer;
